import { AccountOnboardingStep } from '../types';

const accountBaseRoute = '/account';
export const incentivesBaseRoute = '/incentives';
const incentivesWithGidRoute = `${incentivesBaseRoute}/:gid`;
const onboardingBaseRoute = '/onboarding';
export const performanceBaseRoute = '/performance';

export const Routes = {
  account: {
    base: `${accountBaseRoute}`,
    integrations: `${accountBaseRoute}/integrations`,
    invoices: `${accountBaseRoute}/invoices`,
    profile: `${accountBaseRoute}/profile`,
    settings: `${accountBaseRoute}/settings`,
    subscription: `${accountBaseRoute}/subscription`,
  },
  catchAllFail: '/',
  exitIframe: '/exitiframe',
  impersonate: '/impersonate',
  incentives: {
    base: `${incentivesWithGidRoute}`,
    charities: `${incentivesWithGidRoute}/charities`,
    list: incentivesBaseRoute,
    offer: `${incentivesWithGidRoute}/offer`,
    otherSettings: `${incentivesWithGidRoute}/other-settings`,
    overview: `${incentivesWithGidRoute}/overview`,
    promotions: `${incentivesWithGidRoute}/promotions`,
  },
  invoiceDonations: '/invoiceDonations',
  invoices: '/invoices/:invoiceId',
  onboarding: {
    [AccountOnboardingStep.CHARITABLE_CAUSES]: `${onboardingBaseRoute}/causes`,
    [AccountOnboardingStep.GOAL]: `${onboardingBaseRoute}/goal`,
    [AccountOnboardingStep.REFERRAL]: `${onboardingBaseRoute}/referral`,
  },
  overview: '/overview',
  performance: {
    base: `${performanceBaseRoute}`,
    charities: `${performanceBaseRoute}/charities`,
    donations: `${performanceBaseRoute}/donations`,
    orders: `${performanceBaseRoute}/orders`,
    overview: `${performanceBaseRoute}/overview`,
  },
};

export const TabPageRedirectRoutes = {
  [Routes.account.base]: Routes.account.subscription,
  [Routes.incentives.base]: Routes.incentives.overview,
  [Routes.performance.base]: Routes.performance.overview,
};

type Route = {
  redirectPath: string;
  transformQueryParams?: (
    queryParams: URLSearchParams,
    routeParams: Record<string, any>,
  ) => void;
};

export const ServerSideRedirectRoutes: { [key: string]: Route } = {
  [Routes.invoiceDonations]: {
    redirectPath: Routes.performance.donations,
  },
  [Routes.invoices]: {
    redirectPath: Routes.performance.donations,
    transformQueryParams: (queryParams, routeParams) => {
      const paramKey = 'invoiceId';
      const invoiceId = routeParams[paramKey];
      if (invoiceId) {
        queryParams.append(paramKey, invoiceId);
      }
    },
  },
};
